import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#EBFF00",
  "fill-rule": "evenodd",
  d: "M4.332.481h32.14a3.856 3.856 0 0 1 3.86 3.854v32.107a3.856 3.856 0 0 1-3.86 3.855H4.333a3.856 3.856 0 0 1-3.859-3.855V4.335A3.856 3.856 0 0 1 4.332.481m34.302 19.902c0 10.062-8.166 18.218-18.238 18.218S2.16 30.445 2.16 20.383 10.324 2.165 20.396 2.165s18.238 8.156 18.238 18.218",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }